<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://www.betared.sk" target="_blank">BetaRED</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} <span class="fs-10">running v 1.25</span></span>
    </div>
    <div class="mfs-auto">
      <span   target="_blank" >Powered by</span>
      <a href="https://www.betared.sk">   <CIcon
        class="c-sidebar-brand-full"
        name="logo"
        style="color:#000"
        size="custom-size"
        :height="25"
        viewBox="-50 0 456 104"
      /></a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
